module.exports = __webpack_public_path__ + "static/media/priya-profile.8110c46e.jpg";